/**
 * Copyright (c) 2026 Spicy Friends Ltd.
 * All rights reserved.
 *
 * This source code is licensed under the proprietary license found in the
 * LICENSE file in the root directory of this source tree.
 */

export type PaginationRangeEntry = number | 'ellipsis'

/** Builds page numbers and ellipsis markers similar to common pagination UIs. */
export function buildPaginationRange(totalPages: number, page: number, siblingCount = 1): PaginationRangeEntry[] {
  if (totalPages <= 0) {
    return []
  }

  if (totalPages === 1) {
    return [1]
  }

  const delta = siblingCount
  const range = new Set<number>()
  range.add(1)
  range.add(totalPages)

  for (let i = page - delta; i <= page + delta; i++) {
    if (i > 1 && i < totalPages) {
      range.add(i)
    }
  }

  const sorted = [...range].sort((a, b) => a - b)
  const result: PaginationRangeEntry[] = []
  let previous: number | undefined

  for (const num of sorted) {
    if (previous !== undefined && num - previous > 1) {
      result.push('ellipsis')
    }
    result.push(num)
    previous = num
  }

  return result
}
